import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { YMaps } from 'react-yandex-maps';
import { BASE_ROUTE } from './config';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={BASE_ROUTE}>
            <YMaps query={{ load: 'util.bounds' }}>
                <App />
            </YMaps>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('where-to-buy-root')
);
